import React from 'react';
import { motion } from 'framer-motion';
import { UserPlusIcon, LayoutIcon, ActivityIcon } from 'lucide-react';
const steps = [{
  icon: <UserPlusIcon className="h-12 w-12 text-white" data-id="element-169" />,
  title: 'Add your team and clients',
  description: 'Invite team members and clients to join your workspace with different access levels.',
  color: 'bg-brand-blue'
}, {
  icon: <LayoutIcon className="h-12 w-12 text-white" data-id="element-170" />,
  title: 'Create boards and workflows',
  description: 'Set up project boards, task lists, and custom workflows to match your processes.',
  color: 'bg-brand-teal'
}, {
  icon: <ActivityIcon className="h-12 w-12 text-white" data-id="element-171" />,
  title: 'Track progress in real time',
  description: 'Monitor activities, updates, and progress with shared views and activity feeds.',
  color: 'bg-brand-blue'
}];
export const HowItWorks = () => {
  return <section className="py-20 bg-white" data-id="element-172">
      <div className="container-custom" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-174">
          <h2 className="text-3xl font-bold text-brand-blue mb-4" data-id="element-175">
            How Daily Serve works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-176">
            Get started in minutes with these three simple steps.
          </p>
        </motion.div>
        <div className="relative" data-id="element-177">
          {/* Connector line */}
          <div className="absolute top-24 left-0 right-0 h-0.5 bg-gray-200 hidden md:block" data-id="element-178"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-179">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex flex-col items-center text-center" data-id="element-180">
                <div className={`${step.color} w-16 h-16 rounded-full flex items-center justify-center mb-6 relative z-10`} data-id="element-181">
                  {step.icon}
                  <div className="absolute top-0 right-0 w-6 h-6 bg-white rounded-full border-2 border-brand-teal flex items-center justify-center text-sm font-bold text-brand-blue" data-id="element-182">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-brand-blue mb-3" data-id="element-183">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-184">{step.description}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};